<template>
  <div class="positon">
    <!-- <a-menu class="order-sub-menu" mode="horizontal" v-model="topMenuKey">
      <template v-for="item in typeMenus">
        <a-menu-item :key="item.key" class="order-header-button">
          <span>{{ item.name }}</span>
        </a-menu-item>
      </template>
    </a-menu> -->
    <a-tabs :activeKey="status" @change="changeTab">
      <template v-for="tab in tabs">
        <a-tab-pane :key="tab.value" :tab="tab.label"></a-tab-pane>
      </template>
    </a-tabs>
    <a-form :form="form">
      <a-row a-row class="row" justify="space-between" align="middle" :gutter="30">
        <a-col span="8">
          <a-row type="flex" align="top">
            <a-col span="6" class="form-label">发布时间</a-col>
            <a-col span="18">
              <a-form-item>
                <a-range-picker
                  style="display:block"
                  format="YYYY-MM-DD"
                  v-decorator="[
                    'dateModel',
                    { rules: [{ required: false, message: '' }] }
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-col>
        <a-col span="8">
          <a-row type="flex" align="top">
            <a-col span="6" class="form-label">职能</a-col>
            <a-col span="18">
              <a-form-item>
                <a-cascader
                  changeOnSelect
                  v-decorator="[
                    'post',
                    { rules: [{ required: false, message: '请选择职能' }] }
                  ]"
                  :options="functionId"
                  :fieldNames="{
                    label: 'name',
                    value: 'id',
                    children: 'children'
                  }"
                  placeholder="请选择职能"
                  style="display:block"
                  @click="() => loadData('post')"
                ></a-cascader>
              </a-form-item>
            </a-col>
          </a-row>
        </a-col>
        <a-col span="8">
          <a-row type="flex" align="top">
            <a-col span="6" class="form-label">学历</a-col>
            <a-col span="18">
              <a-form-item>
                <a-select placeholder="请选择学历" class="marriage-select" v-model="education_id">
                  <a-select-option :value="0">不限</a-select-option>
                  <a-select-option :value="1">博士</a-select-option>
                  <a-select-option :value="2">MBA/EMBA</a-select-option>
                  <a-select-option :value="3">硕士</a-select-option>
                  <a-select-option :value="4">本科</a-select-option>
                  <a-select-option :value="5">大专</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <a-row a-row class="row" justify="space-between" align="middle" :gutter="30">
        <a-col span="8">
          <a-row type="flex" align="top">
            <a-col span="6" class="form-label">职位名</a-col>
            <a-col span="18">
              <a-input style="display:block" placeholder="请输入关键字" v-model="resumejob"></a-input>
            </a-col>
          </a-row>
        </a-col>
        <a-col span="8">
          <a-row type="flex" align="top">
            <a-col span="6" class="form-label">公司名</a-col>
            <a-col span="18">
              <a-input style="display:block" placeholder="请输入关键字" v-model="companyName"></a-input>
            </a-col>
          </a-row>
        </a-col>
        <a-col span="8">
          <a-row type="flex" align="top">
            <a-col span="6" class="form-label">所在城市</a-col>
            <a-col span="18">
              <a-form-item>
                <a-cascader
                  changeOnSelect
                  v-decorator="[
                    'city',
                    { rules: [{ required: false, message: '请选择城市' }] }
                  ]"
                  :options="area"
                  :fieldNames="{
                    label: 'name',
                    value: 'id',
                    children: 'children'
                  }"
                  placeholder="请选择城市"
                  style="display:block"
                  @click="() => loadData('nation')"
                ></a-cascader>
              </a-form-item>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-form>
    <div class="order-page-type">
      <a-button type="primary" @click="selectList">筛选</a-button>
      <a-button @click="clearSelect" style="margin:0 40px 0 15px">清空筛选条件</a-button>
      <span>共找到 {{ total }} 条信息</span>
      <div style="float:right;color:#f36b1c;padding-top:10px">
        <span>待处理CV：{{total_pending}}</span>
        <a-divider type="vertical"></a-divider>
        <span>已做单CV：{{total_post}}</span>
        <a-divider type="vertical"></a-divider>
        <span>已拒绝CV：{{total_reject}}</span>
      </div>
    </div>
    
    <a-row type="flex" align="middle" justify="start" class="sort-bar">
      <template v-for="sort in sorts">
        <a-col span="3" class="sort" :key="sort.id" @click="changeSort(sort)">
          {{ sort.name }}
          <a-icon :type="`arrow-${sort.arr}`"></a-icon>
        </a-col>
      </template>
    </a-row>

    <a-spin :spinning="loading" size="large">
      <ul class="data-list">
        <!-- <template > -->
        <li
          class="list"
          v-for="(item, index) in listData"
          :key="index"
          @click="showClientMsg(item)"
        >
          <a-row class="row" type="flex" justify="space-between" align="middle">
            <a-col class="content" style="width:35%;">
              <div class="outwrap">
                <span class="company">{{ item.name }}</span>
                <span class="sign" :class="[item.is_urgent == '0' ? 'hide' : 'show']">急</span>
                <span class="morehc" :class="[item.is_mhc == '0' ? 'hide' : 'show']">多HC</span>
              </div>
              <div class="companyStatus">
                <span>{{ item.city_name }}</span>
                <span>|</span>
                <span>招聘{{ item.quantity }}人</span>
                <span>|</span>
                <span>{{ item.education_name }}</span>
                <span>|</span>
                <span>{{ item.experience_name }}</span>
              </div>
              <div class="companyStatus">
                <span>
                  {{ item.company.first_category_name }}/{{
                  item.company.second_category_name
                  }}
                </span>
                <span>|</span>
                <span>{{ item.company.full_name }}</span>
              </div>
            </a-col>
            <a-col class="contentLeft" style="width:25%;">
              <div class="price">{{ item.hunter_salary_min }}-{{ item.hunter_salary_max }}万</div>
              <div class="companyStatus">
                <span>
                  佣金：{{ item.hunter_commission_min }} -
                  {{ item.hunter_commission_max }}
                </span>
              </div>
              <div class="companyStatus">
                <span>
                  保证期：
                  {{
                  item.probation == "0"
                  ? ""
                  : item.probation == "1"
                  ? "1个月"
                  : item.probation == "2"
                  ? "2个月"
                  : item.probation == "3"
                  ? "3个月"
                  : item.probation == "4"
                  ? "6个月"
                  : item.probation == "5"
                  ? "6个月或以上"
                  : null
                  }}
                </span>
              </div>
            </a-col>
            <!-- <a-col class="contentLeft" style="width:30%;">
              <div class="createtime">更新时间:{{ item.updated_at }}</div>
              <div class="look">
                <span
                  >被浏览：<span class="blue">{{ item.num_views }}</span>
                  人</span
                >
                <span class="gap"
                  >已接单：<span class="blue">{{ item.count_posts }}</span>
                  个</span
                >
              </div>
            </a-col>-->
            <a-col class="contentRight">
              <a-row type="flex" :gutter="20">
                <a-col>
                  <div class="edit" @click.stop="goDetail(item, '0')">
                    <a href="javascript:void(0)">{{ item.pending_counts }}</a>
                  </div>
                  <div class="resume">待处理CV</div>
                </a-col>
                <a-col>
                  <div class="edit" @click.stop="goDetail(item, '2')">
                    <a href="javascript:void(0)">{{ item.post_counts }}</a>
                  </div>
                  <div class="resume">已做单CV</div>
                </a-col>
                <a-col>
                  <div class="edit" @click.stop="goDetail(item, '1')">
                    <a href="javascript:void(0)">{{ item.reject_counts }}</a>
                  </div>
                  <div class="resume">已拒绝CV</div>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </li>
        <!-- </template> -->
      </ul>
      <div style="margin-top: 50px;text-align: center" v-show="total == 0">暂无数据</div>
    </a-spin>
    <transition
      enter-active-class="animated fadeInRight"
      leave-active-class="animated fadeOutRight"
    >
      <div class="half-page" v-if="modal === true" @click="toggleJobView">
        <div class="content" @click.stop>
          <a-row type="flex" justify="space-between" align="middle">
            <a-col class="close" @click="toggleJobView">
              <icon-font type="guanbi" :style="{ fontSize: '19px' }" />
            </a-col>
            <a-col class="new_win" @click="toDetail">
              <a-icon type="fullscreen" />在新窗口打开
            </a-col>
          </a-row>
          <Detail :id="post_id" :tab="tab" :authStatus="auth_status"></Detail>
        </div>
      </div>
    </transition>
    <a-row type="flex" align="middle" justify="end" :style="{ padding: '30px 0' }">
      <Pagination ref="pagination" :total="total" @change="getListData" v-show="total != 0"></Pagination>
    </a-row>
    <a-divider></a-divider>
  </div>
</template>

<script>
import Detail from "./detail";
import Pagination from "./Pagination";
import Api from "@/api";

const sorts = [
  {
    name: "综合排序",
    id: 0,
    value: "multi_order_desc",
    arr: "down"
  },
  {
    name: "发布时间",
    id: 1,
    value: "time_order_desc",
    arr: "down"
  },
  // {
  //   name: "佣金",
  //   id: 2,
  //   value: "commission_order_desc",
  //   arr: "down"
  // },
  {
    name: "薪资",
    id: 3,
    value: "salary_order_desc",
    arr: "down"
  },
  {
    name: "待处理CV",
    id: 4,
    value: "pending_count_desc",
    arr: "down"
  },
  {
    name: "已拒绝CV",
    id: 5,
    value: "reject_count_desc",
    arr: "down"
  }
];
export default {
  name: "positon",
  props: {},
  data() {
    return {
      form: this.$form.createForm(this),
      status: 'OK',
      tabs: Object.freeze([
        { label: "招聘中职位", value: "OK" },
        { label: "已下线职位", value: "PAUSED" },
      ]),
      loading: false,
      topMenuKey: [0],
      sorts,
      listData: [],
      pagination: undefined,
      total: 0,
      modal: false,
      post_id: "",
      area: [{ name: "全国", id: 0 }],
      functionId: [{ name: "职能", id: 0 }],
      staticId: [{ name: "学历", id: 0 }],
      list: {
        nation: {
          fun: "getCityTree",
          key: "tree",
          init: { name: "全国", id: 0 }
        },
        post: {
          fun: "getPostTree",
          key: "tree",
          init: { name: "职能", id: 0 }
        },
        static: {
          fun: "getStaticValues",
          key: "tree",
          init: { name: "行业", id: 0 }
        }
      },
      education_id: 0,
      resumejob: undefined,
      companyName: "",
      value: 0,
      order: "multi_order_desc",
      auth_status: "",
      total_pending: 0,
      total_reject: 0,
      total_post: 0
    };
  },
  components: { Detail, Pagination },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    this.pagination = this.$refs.pagination;
    this.getListData();
  },
  methods: {
    changeSort(sort) {
      this.order = sort.value;
      this.getListData();
    },
    changeTab(val) {
      this.status = val;
      this.getListData();
    },
    //候选人select事件
    handleChange(value) {
      console.log(value);
      if (value == "0") {
        this.resumeName = true;
        this.resumeID = false;
      } else if (value == "1") {
        this.resumeName = false;
        this.resumeID = true;
      }
    },
    selectList() {
      this.getListData();
    },
    clearSelect() {
      console.log(123);
      this.form.resetFields();
      this.resumejob = "";
      this.companyName = "";
      this.education_id = "";
      this.getListData();
    },
    async loadData(type) {
      let data = this.list[type];
      let response;
      try {
        response = await Api.common[data.fun]();
      } catch (e) {
        e.message.cached && (response = e.message.data);
      }
      if (type == "nation") {
        this.area = this.joinData(response[data.key]);
      } else if (type == "post") {
        this.functionId = this.joinData(response[data.key]);
      } else {
        this.industry = this.joinData(response[data.key]);
      }
    },
    joinData(data) {
      let init = this.area;
      return [{ ...init }, ...data];
    },
    async getListData(pagination) {
      let moment = require("moment");
      this.loading = true;
      let name,
        id,
        created_start,
        created_end,
        first_category_id,
        second_category_id,
        third_category,
        education_id,
        province_id,
        city_id,
        dist_id;
      this.form.validateFields((err, values) => {
        created_start = values.dateModel
          ? `${moment(values.dateModel[0]).format("YYYY-MM-DD")} 00:00:00`
          : "";
        created_end = values.dateModel
          ? `${moment(values.dateModel[1]).format("YYYY-MM-DD")} 00:00:00`
          : "";
        first_category_id = values.post ? values.post[0] : "";
        second_category_id = values.post ? values.post[1] : "";
        third_category = values.post ? values.post[2] : "";
        province_id = values.city ? values.city[0] : "";
        city_id = values.city ? values.city[1] : "";
        dist_id = values.city ? values.city[2] : "";
      });
      let params = {
        page: this.pagination.current,
        limit: this.pagination.pageSize,
        created_start: created_start,
        created_end: created_end,
        first_category_id: first_category_id,
        second_category_id: second_category_id,
        third_category: third_category,
        education_id: this.education_id,
        name: this.resumejob,
        company_name: this.companyName,
        province_id: province_id,
        city_id: city_id,
        dist_id: dist_id,
        order: this.order,
        status: this.status
      };
      if (pagination) {
        params.page = pagination.current;
        params.limit = pagination.pageSize;
      }
      let response = await Api.position.getList(params);
      if (response) {
        this.loading = false;
        this.listData = response.list;
        this.total = Number(response.total);
        this.total_pending = response.pending_count;
        this.total_reject = response.reject_count;
        this.total_post = response.post_count;
      }
    },
    toggleJobView() {
      this.modal = !this.modal;
    },
    goDetail(record, status) {
      // console.log(record.id)
      this.toggleJobView();
      this.tab = 1;
      this.post_id = record.id;
      this.auth_status = status;
    },
    showClientMsg(record) {
      // console.log(record.id)
      this.toggleJobView();
      this.tab = 2;
      this.post_id = record.id;
    },
    //新窗口中打开
    toDetail() {
      this.toggleJobView();
      let resolveDRoute = this.$router.resolve({
        path: `hunter-job-detail/${this.post_id}`
      });
      window.open(resolveDRoute.href, "_blank");
    }
  }
};
</script>

<style lang="scss">
.positon {
  .ant-form-item-control {
    line-height: 0;
  }
  .order-sub-menu {
    margin-bottom: 20px;
  }
  .noborder {
    border: 0;
  }
  .select {
    width: 100%;
  }
  .order-page-type {
    .clear-screen {
      height: 40px;
      border-radius: 4px;
      color: #5ec9ff;
      border: 1px solid #5ec9ff;
      margin-right: 10px;
      font-weight: bold;
    }
    .screen {
      color: #ffffff;
      height: 40px;
      border-radius: 4px;
      margin-right: 10px;
      font-weight: bold;
    }
    .left {
      position: absolute;
      right: 20px;
    }
  }
  .edit {
    color: #35b5fe;
    margin-bottom: 10px;
    & > a {
      text-decoration: underline;
      font-size: 30px;
      margin-right: 5px;
    }
  }
  .sort-bar {
    text-align: center;
    margin-top: 20px;
    border-radius: 3px;
    background: #35b5fe;
    border: 1px solid rgba(228, 232, 235, 1);
    .sort {
      cursor: pointer;
      font-size: 16px;
      height: 48px;
      line-height: 48px;
      color: #ffffff;
      &.active {
        color: #35b5fe;
      }
    }
  }
  .data-list {
    padding-left: 0;
    li {
      list-style: none;
      cursor: pointer;
      margin-top: 11px;
      border-radius: 3px;
      border: 1px solid rgba(228, 232, 235, 1);
      position: relative;
      padding: 18px 32px 20px 40px;
      &:hover {
        background: #f5f7fa;
      }
      img.shang {
        position: absolute;
        left: 0;
        top: 0;
        width: 35px;
      }
      .row {
        &.row2 {
          padding-top: 10px;
        }
        .col {
          display: flex;
          align-items: center;
          &.gap {
            span:not(:last-child) {
              margin-right: 16px;
            }
          }
          span {
            display: inline-block;
            &.title {
              font-size: 16px;
              font-weight: bold;
            }
            &.ji {
              font-size: 12px;
              background: #ff6b5d;
              border-radius: 2px;
              height: 18px;
              color: #fff;
              padding: 0 3px;
            }
            &.hc {
              background: #f6b502;
              padding: 0 3px;
              font-size: 12px;
              border-radius: 2px;
              height: 18px;
              color: #fff;
            }
            &.time {
              color: #999;
            }
            &.salary {
              font-size: 16px;
              color: #fc5646;
            }
            .anticon {
              font-size: 18px;
              margin-right: 5px;
            }
          }
          a {
            display: inline-block;
            margin-left: 20px;
            img {
              margin-right: 5px;
            }
          }
          .ant-btn {
            margin-left: 20px;
          }
        }
      }
    }
    .contentRight {
      text-align: center;
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 20px;
      border-left: 1px solid #dddddd;
    }
  }
  .outwrap {
    // height: 22px;
    line-height: 22px;
  }
  .sign {
    display: inline-block;
    width: 30px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    background: red;
    font-size: 14px;
    margin-right: 10px;
    color: #ffffff;
  }
  .morehc {
    display: inline-block;
    width: 50px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    background: #35b5fe;
    font-size: 14px;
    margin-right: 10px;
    color: #ffffff;
  }
  .show {
    display: inline-block;
  }
  .hide {
    display: none;
  }
  .company {
    display: inline-block;
    // height: 22px;
    line-height: 22px;
    font-size: 16px;
    font-weight: 500;
    margin-right: 10px;
  }
  .price {
    font-size: 18px;
    font-weight: bold;
    color: red;
  }
  .companyStatus {
    margin: 10px 0;
    font-size: 14px;
  }
  .look {
    margin-top: 40px;
  }
  .blue {
    color: #35b5fe;
  }
  .half-page {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 800;
    .content {
      margin-left: 40%;
      width: 60%;
      min-width: 910px;
      height: 100%;
      overflow: auto;
      background: #fff;
      box-shadow: 0px 0px 44px 0px rgba(0, 0, 0, 0.16);
      padding: 30px 40px;
      .close {
        cursor: pointer;
      }
      .new_win {
        cursor: pointer;
        color: #999;
        display: flex;
        align-items: center;
        .anticon {
          font-size: 16px;
          margin-right: 6px;
        }
      }
    }
  }
}
</style>
